// Module
var code = `<div class="modal-dialog" role="document" data-bind="
		react: {
			component: \$root.ReactSubscriptionLimitModal,
			props: {
				plan: \$root.currentPlanName,
				upgradePlan: \$root.planName,
				kind: \$root.kind,
				upgradeLink: \$root.upgradeLink,
				planLimit: \$root.kind === 'items' ? \$root.maxItems: \$root.maxLocations,				
				onNavigate: (path, args) => { app.router.navigate(path, args); \$root.close(); },
				onClose: () => \$root.close()
			}
		}
	"></div>
`;
// Exports
export default code;